'use client';

import {QueryKey} from '@config/queryKeys';
import {UserService} from '@services/user/user.service';
import {useQuery} from '@tanstack/react-query';

export const useMeQuery = () => {
    const query = useQuery({
        queryKey: [QueryKey.USER],
        queryFn: UserService.getCurrentUser,
    });

    return {query};
};
